import request from './request';
import deserialize from './deserialize';

export type Device = {
  id: string;
  token: string;
  type: string;
  user: {
    id: string;
  };
};

export function register(token: string, deviceType: string) {
  return request<Device>({
    url: '/api/v3/fcm/token',
    method: 'POST',
    data: {
      data: {
        attributes: {
          fcmToken: token,
          type: deviceType,
        },
      },
    },
    transformResponse: deserialize,
  });
}
